import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AutomationFormsAPI from '../../api/automationForms';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAutomationForms(_state) {
    return _state.records;
  },
  getAutomationFormsForAction(_state) {
    return (_state.records || [])
      .filter(form => form.active !== false)
      .map(form => ({
        id: `form:${form.id}`,
        name: form.name,
      }));
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function get({ commit }) {
    commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isFetching: true });
    try {
      const response = await AutomationFormsAPI.get();
      commit(types.SET_AUTOMATION_FORMS, response.data.payload);
    } catch (error) {
      // no-op
    } finally {
      commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isFetching: false });
    }
  },
  create: async function create({ commit }, payload) {
    commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isCreating: true });
    try {
      const response = await AutomationFormsAPI.create(payload);
      commit(types.ADD_AUTOMATION_FORM, response.data.payload);
      return response.data.payload;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isCreating: false });
    }
  },
  update: async function update({ commit }, { id, ...payload }) {
    commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isUpdating: true });
    try {
      const response = await AutomationFormsAPI.update(id, payload);
      commit(types.EDIT_AUTOMATION_FORM, response.data.payload);
      return response.data.payload;
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async function deleteAutomationForm({ commit }, id) {
    commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isDeleting: true });
    try {
      await AutomationFormsAPI.delete(id);
      commit(types.DELETE_AUTOMATION_FORM, id);
    } catch (error) {
      throwErrorMessage(error);
      throw error;
    } finally {
      commit(types.SET_AUTOMATION_FORMS_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_AUTOMATION_FORMS_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_AUTOMATION_FORMS]: MutationHelpers.set,
  [types.ADD_AUTOMATION_FORM]: MutationHelpers.create,
  [types.EDIT_AUTOMATION_FORM]: MutationHelpers.update,
  [types.DELETE_AUTOMATION_FORM]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
